import { Injectable } from '@angular/core';

import { AppInfoConfig } from '@frontend/vanilla/core';

import { ChannelType } from '../config/appConstants';
import { QuickDepositMessageService } from './quick-deposit-message.service';

@Injectable({
    providedIn: 'root',
})
export class ResizeService {
    constructor(
        private appInfo: AppInfoConfig,
        private quickDepositMessageService: QuickDepositMessageService,
    ) {}

    resizeCashier() {
        let height;
        setTimeout(() => {
            height = this.outerHeight('.make-deposit');
            if (height > 100) {
                height = [ChannelType.MW, ChannelType.AW, ChannelType.IW].includes(this.appInfo.channel) ? height + 45 : height;
                this.quickDepositMessageService.sendOutput('action=resize&width=320&height=' + (height + 13));
            }
        }, 200);
    }

    outerHeight(el: any) {
        const my_element = document?.querySelector(el);
        if (my_element) {
            const style = window?.getComputedStyle(my_element);
            return my_element?.getBoundingClientRect().height + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        }
    }
}
